module.exports = __webpack_public_path__ + "img/shield-slash-fill.ddb1453d.svg";